var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#EFEFEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4 18H7.6C7.17565 18 6.76869 17.8314 6.46863 17.5314C6.16857 17.2313 6 16.8243 6 16.4V7.6C6 7.17565 6.16857 6.76869 6.46863 6.46863C6.76869 6.16857 7.17565 6 7.6 6H16.4C16.8243 6 17.2313 6.16857 17.5314 6.46863C17.8314 6.76869 18 7.17565 18 7.6V16.4C18 16.8243 17.8314 17.2313 17.5314 17.5314C17.2313 17.8314 16.8243 18 16.4 18ZM14 12.8V15.2H15.6V12.8H14ZM11.2 8.4V15.2H12.8V8.4H11.2ZM8.4 10.8V15.2H10V10.8H8.4Z",
    fill: "#525254"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStat);
export default __webpack_public_path__ + "static/media/stat.3914ce90cec0c660c8f408cf318c758a.svg";
export { ForwardRef as ReactComponent };